export const STOCK_STATUS_CHECKING = 'checking'
export const STOCK_STATUS_CHECKED = 'checked'
export const STOCK_STATUS_FAILED = 'error'
